<template>
  <div class="bread_crumb">
    <div class="bread_crumb_inner">
      <a @click="toMain" class="home">홈</a>
      <a @click="toCampaign">후원캠페인</a>
      <a>후원캠페인 상세</a>
    </div>
  </div>
  <div class="contents">
    <div class="digitalDetail_wrap">
      <div class="product_area">
        <div class="product_img">
          <div :class="['preview', campaign.campaignType]">
            <img :src="currentThumbnailSrc" />
          </div>
          <div class="thumb_wrap">
            <div class="thumb">
              <div
                v-for="(thumbnail, index) in campaign.attachList"
                :class="[
                  'thumb_item',
                  selectedThumbnailIdx == index ? 'active' : '',
                ]"
              >
                <img
                  @click="selectThumbnail(index)"
                  :src="
                    thumbnail.path
                      ? $getImgUrl(thumbnail.path)
                      : require('../../assets/images/common/campaign_img_01.png')
                  "
                  alt=""
                />
              </div>
            </div>
            <div class="thumb_controller">
              <button class="thumb_prev" @click="changeMainThumbnail('prev')">
                <span>이전</span>
              </button>
              <button class="thumb_next" @click="changeMainThumbnail('next')">
                <span>다음</span>
              </button>
            </div>
          </div>
        </div>
        <div class="product_txt">
          <h5 class="product_tit">
            <span>[{{ campaign.category }}]</span> {{ campaign.campaignName }}
          </h5>
          <div class="tbl_wrap">
            <table>
              <caption>
                기본 정보
              </caption>
              <tbody>
                <tr>
                  <th>유형</th>
                  <td>{{ campaign.category }}</td>
                </tr>
                <tr>
                  <th>제휴사</th>
                  <td>{{ campaign.partnerCompany }}</td>
                </tr>
                <tr>
                  <th>제휴 담당자</th>
                  <td>{{ campaign.partnerManager }}</td>
                </tr>
                <tr>
                  <th>후원타입</th>
                  <td>{{ campaign.type }}</td>
                </tr>
                <tr>
                  <th>상품코드</th>
                  <td>{{ campaign.campaignSeq }}</td>
                </tr>
                <tr>
                  <th>후원기간</th>
                  <td>
                    {{
                      campaign.endDate == "" ? "상시 후원" : campaign.endDate
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="campaign_area">
        <div
          style="
            font-size: 24px;
            font-weight: bold;
            color: #333;
            padding: 100px 0;
          "
          v-html="campaign.content"
        ></div>
      </div>
      <div class="campaign_review_area">
        <div class="tit_area">
          <h5 class="tit">후기</h5>
          <div class="review_type">
            <div class="only_photo">
              <label for="photo">
                <input
                  type="checkbox"
                  id="photo"
                  @change="requestReview"
                  v-model="onlyPhoto"
                />
                <span>포토 리뷰 모아보기</span>
              </label>
            </div>
            <a
              :class="['btn_recent', { active: sortType === 'latest' }]"
              @click="changeSort('latest')"
            >
              최신순
            </a>
            <a
              :class="['btn_high', { active: sortType === 'topRated' }]"
              @click="changeSort('topRated')"
            >
              별점 높은순
            </a>
          </div>
        </div>
        <ul class="caution">
          <li>후기는 디지털화환을 집행하신 이후에 작성하실 수 있습니다.</li>
          <li>
            해당 상품과 무관한 내용, 도배성, 욕설, 상대방에 대한 비방, 명예훼손
            등의 내용을 담고 있거나 저작권/초상권 등 타인의 권리를 침해하는
            내용은 사전 통보없이 삭제될 수 있습니다.
          </li>
        </ul>
        <div class="score_board_wrap">
          <div class="score_board">
            <div class="score_list">
              <div>
                <div class="score_wrap">
                  <div class="score" :data-score="roundedToHalfRating"></div>
                </div>
                <h5>{{ avgRating }}</h5>
              </div>
              <p>총 {{ $addComma(reviewCount) }}건</p>
            </div>
            <ul class="score_stars">
              <li
                v-for="star in [5, 4, 3, 2, 1]"
                :key="star"
                :class="`stars_${star} highlighted`"
              >
                <div class="star_text">{{ star }}점</div>
                <div class="star_bar">
                  <div
                    class="star_fill"
                    :style="`width: ${starPercentages[star]}%`"
                  ></div>
                </div>
                <div class="star_percent">{{ starPercentages[star] }}%</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="review_list">
          <div class="review_item" v-for="review in filteredReviews">
            <div class="review_detail">
              <div class="review_score_wrap">
                <div
                  class="review_score"
                  :data-score="review.reviewRating"
                ></div>
              </div>
              <p>{{ review.reviewText }}</p>
              <ul class="review_photo" v-if="review.attachList.length != 0">
                <li v-for="attach in review.attachList">
                  <img :src="$getImgUrl(attach.path)" alt="" />
                </li>
              </ul>
            </div>
            <div class="review_info">
              <div>
                {{
                  review.userId.slice(0, 2) +
                  "*".repeat(review.userId.length - 2)
                }}
              </div>
              <p>{{ review.createDate }}</p>
            </div>
          </div>
        </div>

        <CustomerServicePagination
          :totalPages="totalPages()"
          :currentPage="currentPage"
          @changePage="changePage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import CustomerServicePagination from "../common/CustomerServicePagination.vue";

const campaignModule = "campaignModule";
const reviewModule = "reviewModule";

export default {
  components: {
    CustomerServicePagination,
  },

  props: {
    campaignSeq: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedThumbnailIdx: 0,
      currentThumbnailSrc: require("../../assets/images/common/campaign_img_01.png"),

      currentPage: 1,
      onlyPhoto: false,
      sortType: "latest",

      filteredReviews: [],

      avgRating: 0,
      roundedToHalfRating: 0,
      starPercentages: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    };
  },

  methods: {
    ...mapActions(campaignModule, ["requestCampaign"]),
    ...mapActions(reviewModule, ["requestReviewListForCampaign"]),

    toMain() {
      this.$router.push({ name: "home" });
    },

    toCampaign() {
      this.$router.push({ name: "CampaignListPage" });
    },

    selectThumbnail(i) {
      this.selectedThumbnailIdx = i;
      this.currentThumbnailSrc = this.$getImgUrl(
        this.campaign.attachList[i].path
      );
    },

    changeMainThumbnail(direction) {
      if (direction == "prev" && this.selectedThumbnailIdx != 0) {
        this.selectedThumbnailIdx -= 1;
        this.currentThumbnailSrc = this.$getImgUrl(
          this.campaign.attachList[this.selectedThumbnailIdx].path
        );
      } else if (
        direction == "next" &&
        this.selectedThumbnailIdx != this.campaign.attachList.length - 1
      ) {
        this.selectedThumbnailIdx += 1;
        this.currentThumbnailSrc = this.$getImgUrl(
          this.campaign.attachList[this.selectedThumbnailIdx].path
        );
      }
    },

    changeSort(sortType) {
      this.sortType = sortType;
      this.requestReview();
    },

    changePage(page) {
      this.currentPage = page;
      this.requestReview();
    },

    totalPages() {
      return Math.ceil(this.reviewCount / 10);
    },

    async requestReview() {
      const { currentPage, campaignSeq, onlyPhoto, sortType } = this;

      await this.requestReviewListForCampaign({
        currentPage,
        campaignSeq,
        sortType,
      });

      this.filteredReviews = onlyPhoto
        ? this.reviews.filter(
            (review) => review.attachList && review.attachList.length > 0
          )
        : this.reviews;

      const totalRating = this.reviews.reduce(
        (sum, review) => sum + review.reviewRating,
        0
      );
      const avgRating =
        this.reviews.length > 0 ? totalRating / this.reviews.length : 0;

      this.avgRating = parseFloat(avgRating.toFixed(1));
      this.roundedToHalfRating = Math.round(this.avgRating * 2) / 2;

      const totalReviews = this.reviews.length;
      const starCounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

      this.reviews.forEach((review) => {
        const roundedRating = Math.round(review.reviewRating);
        starCounts[roundedRating]++;
      });

      Object.keys(starCounts).forEach((star) => {
        this.starPercentages[star] =
          totalReviews > 0
            ? ((starCounts[star] / totalReviews) * 100).toFixed(0)
            : 0;
      });
    },
  },

  computed: {
    ...mapState(campaignModule, ["campaign"]),
    ...mapState(reviewModule, ["reviews", "reviewCount"]),
  },

  async mounted() {
    await this.requestCampaign(this.campaignSeq);
    if (this.campaign.attachList.length != 0) {
      this.currentThumbnailSrc = this.$getImgUrl(
        this.campaign.attachList[0].path
      );
    }

    this.requestReview();
  },
};
</script>
